import { createLazyFileRoute, useNavigate } from "@tanstack/react-router";
import { memo } from "react";

import { CommandMenuProvider } from "@/components/CommandMenu";
import {
  Dialog,
  DialogBody,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Modal } from "@/components/ui/modal";
import { Accession } from "@/features/accession/components/Accession";

export const Route = createLazyFileRoute("/_auth/_app/board/$id")({
  component: memo(() => {
    const params = Route.useParams();
    const { accession } = Route.useLoaderData();
    const navigate = useNavigate();
    return (
      <Modal
        isOpen={true}
        onOpenChange={(flag) => {
          if (!flag) {
            navigate({ to: "/board" });
          }
        }}
      >
        <Dialog className="w-full md:max-w-full m-10">
          <DialogHeader>
            <DialogTitle>Accession {params.id}</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <CommandMenuProvider>
              <Accession accession={accession} />
            </CommandMenuProvider>
          </DialogBody>
        </Dialog>
      </Modal>
    );
  }),
});
